import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ResolvedStore {
  id: number;
  name: string;
  domain: string;
  type: string;
  status: 'active' | 'inactive';
  api_key: string;
}

interface ResolveStoreResponse {
  status: boolean;
  message: string;
  data: ResolvedStore;
}

@Injectable({ providedIn: 'root' })
export class HappyResolveApiService {
  private readonly http = inject(HttpClient);

  resolve(storeName: string, tenant: string): Observable<ResolvedStore> {
    const baseUrl: string = (environment as any).happyApi?.baseUrl || '';
    const url = `${baseUrl}/stores/resolve`;

    const params = new HttpParams()
      .set('domain', storeName)
      .set('type', 'instant_ordering')
      .set('tenant', tenant);

    const headers = new HttpHeaders({
      Accept: 'application/json'
    });

    return this.http
      .get<ResolveStoreResponse>(url, { params, headers })
      .pipe(map((response) => response.data));
  }
}
